import React, {useEffect} from "react";
import { Helmet } from 'react-helmet-async';
import {useHeader} from "../config/headerContext";

const Error404 = () => {
    const {setShowHeader} = useHeader();

    useEffect(() => {
        setShowHeader(false); // Hide Header on mount
        return () => setShowHeader(true); // Show Header on unmount
    }, [setShowHeader]);

    return (
        <>
            <Helmet>
                <title>Error404</title>
            </Helmet>
            <div className="page-404">
                <h1 className="heading heading--1">404</h1>
                <h2 className="heading heading--4">Page not found</h2>
                <a href="/" className="link">Back to home</a>
            </div>
        </>
    );
}

export default Error404;
